import { Link } from "react-router-dom";
import Callout from "../UI/Callout";
// @ts-expect-error pure js
import useAccount from "../../hooks/use-account";

interface DisabledBienNoteProps {
  className?: string;
}

export default function DisabledBienNote({ className }: DisabledBienNoteProps) {
  const { account } = useAccount();
  return (
    <Callout variant="info" className={className}>
      {account.type_abonnement === "gratuit" ? (
        <>
          Utilisation limitée à un bien.{" "}
          <Link to="/mon-compte">Abonnez-vous</Link> (période d’essai gratuite).
          Satisfait ou remboursé 6 mois.
        </>
      ) : (
        <>
          Limite de biens gérables atteinte,{" "}
          <Link to="/mon-compte">augmentez votre abonnement</Link> ou archivez
          des biens actifs.
        </>
      )}
    </Callout>
  );
}
